module.exports = __webpack_public_path__ + "img/3_20.f38a7fcb.png";